import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { authInterceptor } from '@core/auth/auth.interceptor';
import { loadingInterceptor } from '@core/loading/loading.interceptor';
import { AuthService } from '@core/auth/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor, loadingInterceptor])),
    // Recharge l'utilisateur (roles/permissions) avant l'activation du routing
    // quand un token est présent : sans cela, permissionGuard s'exécute avec
    // user = null et boucle entre '/' et 'id-mail'.
    // En cas d'échec : un 401 purge la session via l'interceptor (retour login) ;
    // toute autre erreur (API down) ne bloque pas le démarrage.
    provideAppInitializer(() => {
      const auth = inject(AuthService);
      if (!auth.isAuthenticated()) return;
      return firstValueFrom(auth.fetchMe()).then(
        () => undefined,
        () => undefined,
      );
    }),
  ],
};
